import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3" }
const _hoisted_2 = { class: "card-body p-25" }
const _hoisted_3 = { class: "ps-0 mb-0 list-unstyled pt-3 border-top" }
const _hoisted_4 = {
  class: "d-flex align-items-center",
  style: {"gap":"14px"}
}
const _hoisted_5 = {
  class: "flex-shrink-0 position-relative",
  style: {"top":"-2px"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex-grow-1" }
const _hoisted_8 = { class: "fs-14 fw-semibold mb-0" }
const _hoisted_9 = {
  class: "fs-12 d-block",
  style: {"margin-top":"2px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4\"><h5 class=\"mb-0\">Recent Clients</h5><div class=\"dropdown action-opt\" style=\"right:-8px;\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-vertical\" style=\"stroke:#64748b;\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"> This Day </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"> This Week </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"> This Month </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"> This Year </a></li></ul></div></div>", 1)),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clients, (client) => {
          return (_openBlock(), _createElementBlock("li", {
            key: client.id,
            class: "mb-12 pb-12 border-bottom d-flex justify-content-between align-items-center"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: client.avatar,
                  style: {"max-width":"35px"},
                  alt: "user"
                }, null, 8, _hoisted_6),
                _createElementVNode("div", {
                  class: _normalizeClass(["position-absolute border border-1 border-white rounded-circle status-position2 bottom-0", `bg-${
                  client.status === 'online' ? 'success' : 'body-color'
                }-60`]),
                  style: {"width":"12px","height":"12px"}
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h4", _hoisted_8, _toDisplayString(client.name), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(client.profession), 1)
              ])
            ]),
            _createVNode(_component_RouterLink, {
              to: "/social/profile",
              class: "text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "ri-arrow-right-line fs-18" }, null, -1)
              ]))]),
              _: 1
            })
          ]))
        }), 128))
      ])
    ])
  ]))
}